const milestones = [
  { year: '2008', title: 'Founded in California', desc: 'Born from surfers sick of waiting days for ding repairs — or paying shop rates for minor fixes.' },
  { year: '2011', title: 'SunPowered Patent', desc: 'Developed and patented the first consumer sun-powered (photoinitiated) resin system for surfboards.' },
  { year: '2015', title: 'Global Distribution', desc: 'Products in 30+ countries. Distributed through surf shops across Australia, Europe, and Southeast Asia.' },
  { year: '2019', title: 'Bio-Resin Innovation', desc: 'Launched the industry\'s first bio-resin formula using plant-derived materials — less environmental impact, same performance.' },
  { year: '2024', title: '40,000+ Surfers', desc: 'Trusted in 60+ countries. Preferred by pros, shapers, surf schools, and everyday wave riders worldwide.' },
];

const teamMembers = [
  {
    name: 'Kyle Bennett',
    role: 'Founder & Head of R&D',
    bio: 'Pro surfer turned polymer chemist. Kyle founded PHIX Doctor after one too many dings ruined his trips.',
    image: 'https://public.readdy.ai/ai/img_res/664aa87c3a6dcddf85ea1dac801b53d1.jpg',
  },
  {
    name: 'Maia Santos',
    role: 'Product Development Lead',
    bio: 'Materials scientist. 12 years in marine composites. Leads formulation of all PHIX Doctor resin systems.',
    image: 'https://readdy.ai/api/search-image?query=female%20scientist%20product%20developer%20portrait%20professional%20confident%20beach%20lifestyle%20casual%20modern%20natural%20outdoor%20light%20warm&width=300&height=300&seq=team26b&orientation=squarish',
  },
  {
    name: 'Nico Davel',
    role: 'Global Distribution',
    bio: 'Surfs 200+ days/year across six continents. Manages PHIX Doctor\'s worldwide retail partnerships.',
    image: 'https://readdy.ai/api/search-image?query=male%20distribution%20manager%20surfer%20traveler%20portrait%20casual%20professional%20beach%20lifestyle%20natural%20light%20outdoors%20confident&width=300&height=300&seq=team26c&orientation=squarish',
  },
];

export default function BrandSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-20">
          {/* Story */}
          <div>
            <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-4">Our Story</p>
            <h2 className="text-4xl font-black text-stone-900 mb-6">
              Innovation Born<br /><span className="text-[#0B5C4D]">in the Lineup</span>
            </h2>
            <div className="space-y-4 text-stone-600 leading-relaxed text-base">
              <p>PHIX Doctor started in a California garage in 2008. Founder Kyle Bennett had one frustration: ding repair was slow, messy, and expensive. Traditional resins required hours of cure time, toxic catalyst systems, and precise mixing ratios that left no room for error.</p>
              <p>After years of research into photoinitiated polymer chemistry, Kyle developed a sun-powered resin that needed only natural sunlight to cure. One minute in the sun and the repair was structurally complete — no mixing, no fumes, no waiting.</p>
              <p>What started as a garage experiment became the world&apos;s most trusted surfboard repair brand, used in 60+ countries by everyone from beginners to professional shapers. Today, PHIX Doctor continues to push the boundaries with eco-friendly bio-resin formulations and next-generation UV systems.</p>
            </div>
          </div>

          {/* Timeline */}
          <div className="relative">
            <div className="absolute left-5 top-2 bottom-2 w-0.5 bg-gradient-to-b from-[#FF6B35] to-[#0B5C4D]" />
            <div className="space-y-7 pl-14">
              {milestones.map((m) => (
                <div key={m.year} className="relative">
                  <div className="absolute -left-[38px] w-8 h-8 rounded-full bg-[#0B5C4D] border-2 border-white flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-[#FF6B35]" />
                  </div>
                  <span className="text-[#FF6B35] text-xs font-black uppercase tracking-widest block mb-1">{m.year}</span>
                  <h3 className="text-stone-900 font-bold text-base mb-1">{m.title}</h3>
                  <p className="text-stone-500 text-sm leading-relaxed">{m.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team */}
        <div className="text-center mb-12">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">The Team</p>
          <h2 className="text-4xl font-black text-stone-900">Surfers Who <span className="text-[#0B5C4D]">Build Stuff</span></h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {teamMembers.map((m) => (
            <div key={m.name} className="text-center bg-[#F5EFE6] rounded-2xl p-8">
              <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-5 border-4 border-white">
                <img src={m.image} alt={m.name} className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="text-stone-900 font-black text-base mb-0.5">{m.name}</h3>
              <p className="text-[#FF6B35] text-sm font-semibold mb-3">{m.role}</p>
              <p className="text-stone-500 text-sm leading-relaxed">{m.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
